import { Component, type ReactNode } from 'react';

interface State {
  hasError: boolean;
}

export class RootErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  reset = () => this.setState({ hasError: false });

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
